import { useFormDataQuery } from '@/api/getters';
import { ConflictTypes } from '@/api/types';
import ProgressBarFinished, {
  StepFinished,
} from '@/components/ui/ProgressBarFinished';
import { ProgressType } from '@/features/v2/lib/wizard';

import { useLingui } from '@lingui/react';

const ProgressFinished = ({
  steps,
  variant,
}: {
  steps: StepFinished[];
  variant: ProgressType;
}) => {
  const { data } = useFormDataQuery();
  const { i18n } = useLingui();

  if (!data) return null;

  const isComplementaryConflict =
    data?.conflict === ConflictTypes.CONFLICTS_STAGE_IV_COMPLEMENTARY;

  if (variant === 'contact_us') {
    return (
      <ProgressBarFinished
        steps={[
          {
            label: data.offer.is_complementary
              ? i18n.t('Uzupełnienie informacji')
              : i18n.t('Weryfikacja szkody'),
            checked: data.offer.is_complementary ? false : true,
            unChecked: data.offer.is_complementary ? true : false,
            active: true,
          },
        ]}
      />
    );
  }

  if (variant === 'ready_doc') {
    return (
      <ProgressBarFinished
        steps={[
          {
            label: i18n.t('Pobieranie umowy'),
            checked: true,
            active: true,
          },
        ]}
      />
    );
  }

  if (variant === 'ups') {
    return (
      <ProgressBarFinished steps={steps} withProgress progressFromProps={50} />
    );
  }

  if (variant === 'not_qualified') {
    return (
      <ProgressBarFinished
        steps={[
          {
            label: data.offer.is_complementary
              ? i18n.t('Uzupełnienie informacji')
              : i18n.t('Weryfikacja szkody'),
            checked: false,
            unChecked: true,
            active: true,
          },
        ]}
      />
    );
  }

  if (variant === 'conflict') {
    return (
      <ProgressBarFinished
        steps={[
          {
            label: isComplementaryConflict
              ? i18n.t('Uzupełnienie informacji')
              : i18n.t('Generowanie dokumentów'),
            checked: false,
            unChecked: true,
            active: true,
          },
        ]}
      />
    );
  }

  return <ProgressBarFinished steps={steps} withProgress={true} />;
};

export default ProgressFinished;
